import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Tab from 'react/containers/layout/tabs/Tab';

import TicketDetailsContainer from './TicketDetailsContainer';
import ticketDetails from 'react/api/actions/ticketDetails';

class TicketDetails extends Tab {
  activeClassName = 'is-active';

  componentDidMount() {
    const {
      tab: { pathname, key },
      updateTitle,
      getTicketDetailsAction
    } = this.props;

    const id = this.getTicketId(pathname);

    if (id) {
      this.setTabTitle(updateTitle, key, id);
      getTicketDetailsAction({ key, id });
    }
  }

  getTicketId = (pathname) => {
    const params = pathname.split('/');

    return +params[3];
  }

  setTabTitle = (updateTitle, key, id) => {
    updateTitle({
      key,
      title: `${Monet.I18n.getResourcesByKey('TicketDetails.title')} (${id})`
    });
  }

  render() {
    const { active } = this.props;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;
    return (
      <TicketDetailsContainer className={className} {...this.props} />
    );
  }
}

TicketDetails.propTypes = {
  onClose: PropTypes.func,
  active: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
  data: state.ticketDetails.getIn([ownProps.tab.key], {}),
  isLoading: state.ticketDetails.getIn(['isLoading']),
  isProcessingComment: state.ticketDetails.getIn(['isProcessingComment']),
  userLoggedId: state.user.get('id', 0),
  isLoadingChatData: state.ticketDetails.getIn(['isLoadingChatData'])
});

const mapDispatchToProps = {
  getTicketDetailsAction: ticketDetails.actionCreators.getTicketDetails,
  handlePersistCommentAction: ticketDetails.actionCreators.handlePersistComment,
  handleDeleteCommentAction: ticketDetails.actionCreators.handleDeleteComment
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketDetails);
